import React, { useState } from 'react'
import { DataTable, Button } from '@paypalcorp/pp-react'

interface ICellType {
  value: string[]
}

const CardBrandCell = ({ value }: { value: ICellType }) => {
  return (
    <>
      {value.map((brand: string, i: number) => (
        <span key={`cardbrand-${i}`}>
          {i === value.length - 1 ? (
            <span>{brand}</span>
          ) : (
            <>
              <span>{brand},</span>
              <br />
            </>
          )}
        </span>
      ))}
    </>
  )
}

const CurrenciesCell = ({ value }: { value: ICellType }) => {
  return (
    <>
      {value.map((cur: string, i: number) => {
        // eslint-disable-next-line no-nested-ternary
        return cur === 'HKD' ? (
          <>
            <code>{cur}</code>, <br />
          </>
        ) : i === value.length - 1 ? (
          <code>{cur}</code>
        ) : (
          <>
            <code>{cur}</code>,
          </>
        )
      })}
    </>
  )
}

const allRows = [
  {
    id: 'row1',
    country: {
      value: 'Australia',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express (AUD only)'],
    },
    currencies: {
      value: [
        'AUD',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'JPY',
        'NOK',
        'NZD',
        'PLN',
        'SEK',
        'SGD',
        'USD',
      ],
    },
  },
  {
    id: 'row2',
    country: {
      value: 'Canada',
    },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express (CAD only)',
        'JCB (CAD only)',
      ],
    },
    currencies: {
      value: [
        'AUD',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'JPY',
        'NOK',
        'NZD',
        'PLN',
        'SEK',
        'SGD',
        'USD',
      ],
    },
  },
  {
    id: 'row3',
    country: {
      value: 'France',
    },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express (EUR only)',
        'Carte Bancaire',
      ],
    },
    currencies: {
      value: [
        'AUD',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'JPY',
        'NOK',
        'NZD',
        'PLN',
        'SEK',
        'SGD',
        'USD',
      ],
    },
  },
  {
    id: 'row4',
    country: {
      value: 'Germany',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express (EUR only)'],
    },
    currencies: {
      value: [
        'AUD',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'JPY',
        'NOK',
        'NZD',
        'PLN',
        'SEK',
        'SGD',
        'USD',
      ],
    },
  },
  {
    id: 'row5',
    country: {
      value: 'Italy',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express (EUR only)'],
    },
    currencies: {
      value: [
        'AUD',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'JPY',
        'NOK',
        'NZD',
        'PLN',
        'SEK',
        'SGD',
        'USD',
      ],
    },
  },
  {
    id: 'row6',
    country: {
      value: 'Spain',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express (EUR only)'],
    },
    currencies: {
      value: [
        'AUD',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'JPY',
        'NOK',
        'NZD',
        'PLN',
        'SEK',
        'SGD',
        'USD',
      ],
    },
  },
  {
    id: 'row7',
    country: {
      value: 'United States',
    },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express (USD only)',
        'Discover (USD only)',
        'Debit networks (Star/Star Access, Pulse, Nyce, Accel)',
      ],
    },
    currencies: {
      value: ['AUD', 'CAD', 'EUR', 'GBP', 'JPY', 'USD'],
    },
  },
  {
    id: 'row8',
    country: {
      value: 'United Kingdom',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express (GBP, USD only)'],
    },
    currencies: {
      value: [
        'AUD',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'JPY',
        'NOK',
        'NZD',
        'PLN',
        'SEK',
        'SGD',
        'USD',
      ],
    },
  },
  {
    id: 'row9',
    country: {
      value: 'Mexico',
    },
    cardBrand: {
      value: ['Mastercard', 'Visa', 'American Express'],
    },
    currencies: {
      value: ['MXN'],
    },
  },
  {
    id: 'row10',
    country: {
      value: 'Japan',
    },
    cardBrand: {
      value: [
        'Mastercard',
        'Visa',
        'American Express (JPY only)',
        'JCB (JPY only)',
      ],
    },
    currencies: {
      value: [
        'AUD',
        'CAD',
        'CHF',
        'CZK',
        'DKK',
        'EUR',
        'GBP',
        'HKD',
        'HUF',
        'JPY',
        'NOK',
        'NZD',
        'PLN',
        'SEK',
        'SGD',
        'USD',
      ],
    },
  },
]

const columns = {
  country: {
    title: 'Currency',
    width: '10%',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  cardBrand: {
    title: 'Card brand',
    cellAs: CardBrandCell,
    width: '15%',
    mobile: {
      placement: 'b3',
    },
  },
  currencies: {
    title: 'Currencies',
    cellAs: CurrenciesCell,
    width: '20%',
    mobile: {
      placement: 'b3',
    },
  },
}

const CurrencyCardBrandTable = () => {
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const showSeeMoreBtn = rows.length < allRows.length

  const handleSeeMore = () => {
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }

  return (
    <>
      <DataTable
        description="Basic"
        rows={rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default CurrencyCardBrandTable
